import { useMutation } from '@apollo/client';
import { gql } from '@/__generated__';

const MediaUploadUrlMutation = gql(`
  mutation MediaUploadUrl($input: MediaUploadUrlInput!) {
    mediaUploadUrl(input: $input) {
      url
      key
    }
  }
`);

export const useMediaUploadUrl = () => {
  const [mutate] = useMutation(MediaUploadUrlMutation);

  return async ({
    key,
    contentType,
  }: {
    key: string;
    contentType: string;
  }): Promise<string> => {
    const { data } = await mutate({
      variables: { input: { key, contentType } },
    });
    const url = data?.mediaUploadUrl.url;
    if (!url) {
      throw new Error('Failed to obtain a media upload URL');
    }
    return url;
  };
};
